import { connect } from 'react-redux';
import { push } from "react-router-redux";
import Faq from '../components/Faq/Faq';

const mapStateToProps = (state) => {
  return {
    pathname: state.router.location.pathname,
  };
};

const mapDispatchToProps = dispatch => ({
  goTo(url, state) {
    dispatch(push(url, state));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Faq);



// WEBPACK FOOTER //
// ./src/containers/Faq.js